module.exports = __webpack_public_path__ + "static/img/2.0a62d3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/document/4/2.png
// module id = Ia5a
// module chunks = 1